module.exports = __webpack_public_path__ + "img/ueber-mich-2_1280.c1de63d3.webp";